import { createAsyncThunk } from '@reduxjs/toolkit';
import { getImportIntegrationPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetImportIntegrationPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getImportIntegrationPodDataByContactId',
  async ({ psaId, contactId }) =>
    getImportIntegrationPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
